$('.confirm-print').on('click', function (e) {
    e.preventDefault();

    let link = $(this).attr('href');
    let text = getText($(this).attr('data-text'));

    showPrintSweetAlert(text, link);

});

function showPrintSweetAlert(text, link) {
    Swal.fire({
        title: 'Sicherheitsabfrage',
        icon: 'question',
        text: text,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Nein',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#d33'
    }).then((result) => {
        if (result.value) {
            window.location.href = link
        }
    });
}

function getText(text) {
    if(text === undefined) {
        return 'Ein VK Preis ist 0€ trotzdem fortfahren?';
    } else {
        return text;
    }
}
